"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAR_OPTIONS = exports.RescheduleWith = exports.AssignmentMode = exports.MemberSubType = exports.MemberType = void 0;
var MemberType;
(function (MemberType) {
    MemberType["SUMO1"] = "SUMO1";
    MemberType["GOOGLE_CONTACTS"] = "GOOGLE_CONTACTS";
    MemberType["MICROSOFT_CONTACTS"] = "MICROSOFT_CONTACTS";
    MemberType["SALESFORCE"] = "SALESFORCE";
    MemberType["HUBSPOT"] = "HUBSPOT";
    MemberType["SALESFORCE_CEP"] = "SALESFORCE_CEP";
    MemberType["CUSTOM"] = "CUSTOM";
    MemberType["MS_DYNAMICS"] = "MS_DYNAMICS";
})(MemberType = exports.MemberType || (exports.MemberType = {}));
var MemberSubType;
(function (MemberSubType) {
    MemberSubType["ANY"] = "ANY";
    MemberSubType["USER"] = "USER";
    MemberSubType["TEAM"] = "TEAM";
    MemberSubType["CONTACT"] = "CONTACT";
    MemberSubType["PERSON_ACCOUNT"] = "PERSON_ACCOUNT";
    MemberSubType["LEAD"] = "LEAD";
    MemberSubType["RESOURCE"] = "RESOURCE";
    MemberSubType["BUCKET"] = "BUCKET";
})(MemberSubType = exports.MemberSubType || (exports.MemberSubType = {}));
var AssignmentMode;
(function (AssignmentMode) {
    AssignmentMode["ROUND_ROBIN"] = "ROUND_ROBIN";
    AssignmentMode["RANDOM"] = "RANDOM";
})(AssignmentMode = exports.AssignmentMode || (exports.AssignmentMode = {}));
var RescheduleWith;
(function (RescheduleWith) {
    RescheduleWith["ASSIGNED_HOST"] = "ASSIGNED_HOST";
    RescheduleWith["ROUND_ROBIN_TO_NEW_HOST"] = "ROUND_ROBIN_TO_NEW_HOST";
})(RescheduleWith = exports.RescheduleWith || (exports.RescheduleWith = {}));
exports.STAR_OPTIONS = [
    "USER" /* MemberSubType.USER */,
    "CONTACT" /* MemberSubType.CONTACT */,
    "PERSON_ACCOUNT" /* MemberSubType.PERSON_ACCOUNT */,
    "LEAD" /* MemberSubType.LEAD */,
    "TEAM" /* MemberSubType.TEAM */,
];
